// Brand registry for the admin portal (identity only: name, title, logos).
//
// REACT_APP_BRAND selects one of ./brands/*.js at build time. There is
// deliberately no default: a build that does not name its brand fails
// immediately instead of shipping another company's identity. The admin UI
// keeps its own neutral colour scheme for every brand.
import upwardor from "./brands/upwardor";
import encore from "./brands/encore";

const registry = { upwardor, encore };

const key = String(process.env.REACT_APP_BRAND || "").trim();
if (!key) {
  throw new Error(
    "[brand] REACT_APP_BRAND is not set. Add REACT_APP_BRAND=<upwardor|encore> to the .env used for this build."
  );
}
if (!registry[key]) {
  throw new Error(
    `[brand] Unknown REACT_APP_BRAND "${key}". Known brands: ${Object.keys(registry).join(", ")}.`
  );
}

export const brand = Object.freeze(registry[key]);

/** Apply brand identity to the document. Call once, before rendering. */
export const applyBrand = () => {
  document.documentElement.setAttribute("data-brand", brand.key);
  document.title = brand.title;

  const setLink = (rel, href, type) => {
    let el = document.querySelector(`link[rel="${rel}"]`);
    if (!el) {
      el = document.createElement("link");
      el.rel = rel;
      document.head.appendChild(el);
    }
    el.href = href;
    if (type) el.type = type;
  };
  setLink(
    "icon",
    brand.assets.favicon,
    brand.assets.favicon.endsWith(".svg") ? "image/svg+xml" : ""
  );
  setLink("apple-touch-icon", brand.assets.favicon);
  setLink("manifest", brand.assets.manifest);
};

export default brand;
